import type { AppState, AppAction } from '../appReducerTypes';

export function chatReducer(state: AppState, action: AppAction): AppState {
  switch (action.type) {
    case 'SET_CHAT_JOURNAL_ENTRIES':
      return { ...state, chatJournalEntries: action.payload };
    case 'ADD_CHAT_JOURNAL_ENTRY':
      return {
        ...state,
        chatJournalEntries: [action.payload, ...state.chatJournalEntries],
      };
    case 'DELETE_CHAT_JOURNAL_ENTRY':
      return {
        ...state,
        chatJournalEntries: state.chatJournalEntries.filter((entry) => entry.id !== action.payload),
      };
    case 'SET_LAST_CHAT_JOURNAL_SIZE':
      return { ...state, lastChatJournalSize: action.payload };
    default:
      return state;
  }
}
